<script lang="ts" setup>
import { computed } from "vue";

import type { UnpackedBadge } from "@/common/types/vocab";

const props = defineProps<{
  badge: UnpackedBadge;
  responsive?: boolean;
  xl?: boolean;
}>();

const isResponsive = computed(() => {
  if (props.xl) {
    return false;
  }

  return props.responsive;
});

const classModifiers = computed<string[]>(() => {
  const modifiers: string[] = [];

  if (isResponsive.value) {
    modifiers.push("responsive");
  }

  if (props.xl) {
    modifiers.push("xl");
  }

  return modifiers;
});

const rootElementModifiers = computed(() =>
  classModifiers.value.map((modifier) => `achievement-badge--${modifier}`)
);

const imgElementModifiers = computed(() =>
  classModifiers.value.map((modifier) => `achievement-badge__img--${modifier}`)
);
</script>

<template>
  <div class="achievement-badge" :class="rootElementModifiers">
    <img
      loading="lazy"
      class="achievement-badge__img"
      :class="imgElementModifiers"
      :src="`/assets/img/vocab/achievements/badges/${badge.name}.png`"
      :alt="badge.displayName"
    />
  </div>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.small-style {
  width: 34px;
  min-width: 34px;
  height: 34px;
  min-height: 34px;
}

.large-style {
  width: 56px;
  min-width: 56px;
  height: 56px;
  min-height: 56px;
}

.xl-style {
  width: 89px;
  min-width: 89px;
  height: 89px;
  min-height: 89px;
}

.achievement-badge {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  .large-style();

  &--responsive {
    .small-style();

    #media-breakpoint-up(lg, {
      .large-style();
    });
  }

  &--xl {
    .xl-style();
  }

  &__img {
    width: 100%;
    height: 100%;
  }
}
</style>
